import { CheckCircleOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { getValueByPath } from 'modules/common/utils/getValueByPath';
import { FC, useMemo } from 'react';
import { Control, useFormContext, useWatch } from 'react-hook-form';

import styles from './styles.module.scss';

import { petSchema } from '../../schema/petSchema';

export const PetAccordionTitle: FC<{
  control: Control<any>;
  index: number;
  defaultTitle: string;
}> = ({ control, index, defaultTitle }) => {
  const {
    formState: { errors },
  } = useFormContext();

  const petData = useWatch({
    control,
    name: `pets.${index}`,
  });

  const isDataValid = useMemo(() => {
    if (!petData) {
      return false;
    }

    const isSchemaValid = petSchema.isValidSync(petData);

    const hasRhfErrors = !!getValueByPath(errors, `pets.${index}`);

    return isSchemaValid && !hasRhfErrors;
  }, [petData, errors, index]);

  const displayName = petData?.name || defaultTitle;

  return (
    <Space>
      {isDataValid && <CheckCircleOutlined className={styles.checkMark} />}
      {displayName}
    </Space>
  );
};
